<div 
    v-if="filters.length"
    class="grid grid-x grid-margin-x align-middle pagelist-filters margin-bottom-3">
    <template v-for="filter of filters">
        <div  
            v-if="filter.options.length"
            class="pagelist-filter js-pagelist-filter"
            @mouseleave="closeFilter($event)"
        >
            <div 
                class="pagelist-filter-options"
            >
                <span class="pagelist-filter-description bold-text">Filter By:</span>
                <div
                    v-for="(option, index) in filter.options"
                    class="pagelist-filter-option"
                >   
                    <!--
                        the final checkbox needs a 'closeFilter'
                        function on blur (to enable us to have
                        filters close automatically when we
                        navigate between them using the keyboard)
                    -->
                    <input 
                        type="checkbox" 
                        :id="option.id"
                        :value="option.id"
                        class="pagelist-filter-checkbox"
                        :name="option.name"
                        :data-filter="filter.id"
                        :checked="option.checked"
                        @change=handleCheckbox($event)
                        v-if="index === (filter.options.length - 1)"
                        @blur="closeFilter($event)"
                    >
                    <input 
                        type="checkbox" 
                        :id="option.id"
                        class="pagelist-filter-checkbox"
                        :value="option.id"
                        :name="option.name"
                        :data-filter="filter.id"
                        :checked="option.checked"
                        @change=handleCheckbox($event)
                        v-else
                    >
                    <label 
                        :for="option.id"
                        class="pagelist-filter-label"
                    >
                        {{ option.name }}
                    </label>                
                </div>
            </div>
        </div>
    </template>
</div>
